<template>
    <div>
        <div style="padding-top: 15px">
            <el-button type="primary" @click="showEditFunc()">新增</el-button>
            <el-button type="primary" @click="showBack()">返回</el-button>
        </div>
        <div class="common-table">
            <el-table v-loading="loading" :data="firstList" height="100%" row-key="id">
                <el-table-column align="center">
                    <el-table-column align="center" label="等级" prop="grade">
                      <template slot-scope="scope">第 {{scope.row.grade}} 名</template>
                    </el-table-column>
                    <el-table-column align="center" label="等级奖励" prop="reward">
                      <template slot-scope="scope">{{scope.row.reward | numberChip}}</template>
                    </el-table-column>
                  <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                          <el-button type="primary" size="mini" @click="showEditFunc(2,scope.row)">编辑</el-button>
                          <el-button type="danger" size="mini" @click="deleteEdit(scope.row.grade)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>

        <div v-show="show" class="common-popup-bg">
            <div class="common-popup" style="width: 400px">
                <h3>{{form.op===1?'新增玩家奖励':'修改玩家奖励'}}</h3>
                <el-form ref="rewardMttEdt"
                         size="medium"
                         :model="form"
                         :rules="rules"
                         class="common-popup-table"
                         label-width="90px">
                  <el-form-item label="等级奖励:" prop="reward" >
                    <el-input type="number" resize="none" v-model="form.reward" placeholder="获得玩家等级奖励"/>
                  </el-form-item>
                </el-form>
                <footer>
                    <el-button size="small" @click="close('rewardMttEdt')">取消</el-button>
                    <el-button size="small" type="primary" @click="submitForm('rewardMttEdt')">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapState} from 'vuex'
    export default {
        props:["rewardList"],
        data() {
            return {
                id: null,
                show: false,
                loading: false,
                list: [],
                form: {
                    op: null,// 新增：1 编辑：2
                    id:'',
                    reward: 0
                },
              rules: {
                reward: [
                  {required: true, message: '请输入服务费', trigger: 'blur'},
                ]
              },
            }
        },
        computed:{
            ...mapState('login', ['permissions']),
            ...mapGetters('rankingAward', ['getRankingAward']),
            firstList(){
                return this.list;
            },
        },
        created() {
            this.getList();
        },
        methods: {
            ...mapActions('rankingAward', ['getRankingAwardList', 'addRankingAward', 'updateRankingAward', 'deleteRankingAward']),
            arraySpanMethod({row, columnIndex}) {
                if (columnIndex === 0) {
                    return {
                        rowspan: row.rowspan,
                        colspan: row.colspan
                    };
                }
            },

            getList() {
                this.loading = true;
                this.getRankingAwardList().then(res => {
                    this.loading = false;
                    this.list = res.data;
                    this.close(res);
                    }
                )
            },
          deleteEdit(id){
              this.deleteRankingAward(id).then(()=>{
                this.$message.success('删除成功');
                this.getList();
              })
            },
            showEditFunc(op=1, obj = null) {
                this.form.op = op;
                if (op === 2) {
                    this.form = Object.assign({}, this.form, {
                        id:obj.id,
                        grade: obj.grade,
                        reward:obj.reward/100,
                    })
                }
                this.show = true;
            },
            showBack(){
              this.$emit("editRewardList",false);
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let {op, ...params} = this.form;
                            if (op === 1) {
                                params.reward=params.reward*100;
                                this.addRankingAward(params).then(() => {
                                    this.$message.success('添加成功');
                                    this.getList();
                                    this.close(formName)
                                })
                            } else if (op===2){
                                params.reward=params.reward*100;
                                this.updateRankingAward(params).then(() => {
                                    this.$message.success('修改成功');
                                    this.getList();
                                    this.close(formName)
                                })
                            }
                    }
                });
            },
            close(formName) {
                if (this.$refs[formName] !== undefined) {
                    this.$refs[formName].resetFields();
                }
                this.show = false;
            }
        }
    }
</script>